module.exports = __webpack_public_path__ + "static/Rheinhessen1-scaled-a6afea51a69d49669dd60e04f07d2ee7.jpeg";